import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'トップ' },
    { path: '/business', label: '事業内容' },
    { path: '/products', label: '製品・工場案内' },
    { path: '/company', label: '会社概要' },
    { path: '/recruit', label: '求人情報' },
    { path: '/contact', label: 'お問い合わせ' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || !isHome
            ? 'bg-white shadow-md'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center">
              <h1
                className={`text-xl sm:text-2xl font-bold transition-colors ${
                  isScrolled || !isHome ? 'text-navy' : 'text-white'
                }`}
              >
                おかやまネジ製作所
              </h1>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors hover:text-navy-light whitespace-nowrap ${
                    isScrolled || !isHome ? 'text-navy' : 'text-white'
                  } ${location.pathname === link.path ? 'border-b-2 border-current' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:086-012-3456"
                className="bg-navy text-white px-6 py-2 rounded-lg font-medium hover:bg-navy-light transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center transition-colors ${
                isScrolled || !isHome ? 'text-navy' : 'text-white'
              }`}
              aria-label="メニュー"
            >
              <i className={`text-3xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-opacity duration-300 ${
          isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="absolute inset-0 bg-black/50" onClick={() => setIsMobileMenuOpen(false)}></div>
        <nav className="absolute top-20 left-0 right-0 bg-white shadow-lg">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-6 py-4 text-navy font-medium border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                  location.pathname === link.path ? 'bg-navy/5' : ''
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:086-012-3456"
              className="mx-6 my-4 bg-navy text-white px-6 py-3 rounded-lg font-medium text-center hover:bg-navy-light transition-colors"
            >
              <i className="ri-phone-line mr-2"></i>
              086-012-3456
            </a>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;